/**
 * DO NOT MODIFY
 * This file is generated by StashInvest/product-events
 * To open an issue, go to https://github.com/StashInvest/product-events/issues/new/choose
 */

import Identity from '../identity.js';
import { v1_IdentifyProperties } from './properties.js';

export function v1_Identify(payload) {
    const properties = new v1_IdentifyProperties(payload);
    const results = new Identity(properties).track();
    return {
        properties: results,
        context: properties.context(),
    };
}
